import { NotificationsHostProps } from 'piral'
import * as React from 'react'

export default function NotificationsHost(props: NotificationsHostProps) {
    return (
        <></>
    )
}
